"use strict";

import angular from "angular";

function natureOfAccountDirective() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ctrl) {
            element.on("change", function () {
                scope.$apply(function () {
                    let newValue = "";
                    if (
                        attrs.natureOfAccount === "negative" &&
                        ctrl.$modelValue > 0
                    )
                        newValue = ctrl.$modelValue * -1;
                    else return (newValue = ctrl.$modelValue);
                    const stringValue = String(newValue).replace(".", ",");
                    const splitted = stringValue.split(",");
                    if (!splitted[1]) {
                        ctrl.$setViewValue(`${splitted[0]},00`);
                        ctrl.$render();
                        return;
                    }
                    const decimal = splitted[1].padEnd(2, "0");
                    ctrl.$setViewValue(`${splitted[0]},${decimal}`);
                    ctrl.$render();
                });
            });
        }
    };
}

const name = "natureOfAccount";
const factory = natureOfAccountDirective;
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
